import Content from './ActivityItemContent';
import Header from './ActivityItemHeader';
import JsonPanel from './ActivityItemJsonPanel';
import Panel from './ActivityItemPanel';
import Root from './ActivityItemRoot';
import Section from './ActivityItemSection';
import Tab from './ActivityItemTab';
import TabPanel from './ActivityItemTabPanel';
import Tabs from './ActivityItemTabs';

export const ActivityItem = {
  Root,
  Header,
  Content,
  Tabs,
  Tab,
  TabPanel,
  JsonPanel,
  Section,
  Panel,
};
